import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.backgroundPrimary,
    padding: theme.spacing[7],
  },
  content: {
    gap: theme.spacing[5],
    alignItems: 'stretch',
    maxWidth: theme.breakpoints.mobile,
  },
}));
